<template>
  <div class="lg:mb-10 lg:flex lg:items-start">
    <div class="lg:grid lg:cols-2 lg:grow lg:gap-2 <lg:space-y-1">
      <div
        v-for="i in 6"
        :key="i"
        class="skeleton"
        :style="{ 'aspect-ratio': presets.src.width / presets.src.height }"
      />
    </div>
    <div v-style:w="{ lg: '25.5rem' }" class="lg:sticky lg:top-0 lg:shrink-0 lg:px-4 lg:pt-6 <lg:hidden">
      <div class="mr-2 w-full flex justify-end">
        <div class="h-4 w-24 skeleton" />
      </div>
      <div class="mt-2 h-7 w-64 skeleton" />
      <div class="mt-0.5 h-4 w-30 skeleton" />
      <div class="mt-2 h-5 w-20 skeleton" />
      <div class="mt-2 flex gap-1 wrap">
        <div
          v-for="i in 5"
          :key="i"
          class="skeleton rounded"
          :style="{ width: '4.5rem', height: '5.625rem' }"
        />
      </div>
      <div class="mt-2 h-4 w-24 skeleton" />
      <div class="mt-6 h-5 w-16 skeleton" />

      <div class="mt-2 h-13 w-full skeleton" />
      <div class="mt-2 h-4 w-24 skeleton" />
      <div class="mt-4 h-13 w-full skeleton" />
      <div class="mt-4 b b-grey-70">
        <div class="h-20 w-full skeleton b-b b-grey-70" />
        <div class="h-20 w-full skeleton" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { presets } = useAppConfig().pages.pdp.gallery
</script>
